
import { initMobilePartnersToggle } from "../partners/mobile-toggle";
import { initFaqDefaultToggle } from "../ajuda/faq-default-toggle";
import "../bootstrap-init";

// Remove src from midia images (existing behavior)
$(document).ready(() => {
  initMobilePartnersToggle();
  initFaqDefaultToggle();
  $("#quiteja-midia figure img").removeAttr("src");
});
